import { Questions } from '../Questions/Questions'
import * as R from 'ramda'
import React from 'react'
import styles from './Sections.module.scss'
import { Box } from 'components/layout/Box/Box'

export const Sections = ({ sections, isWordDoc }) => (
  <Box className={styles.questions} direction="column">
    {R.map(
      ({ questions, id, title }) => (
        <Box direction="column" key={id} className={styles.question}>
          {isWordDoc ? (
            <p className={styles.sectionTitle}>{title}</p>
          ) : (
            <div className={styles.sectionTitle}>{title}</div>
          )}
          <Questions questions={questions} isWordDoc={isWordDoc} />
        </Box>
      ),
      sections,
    )}
  </Box>
)
